var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { AddEsigningRecipientDocument } from './mutation.gql';
import { useEsigningProviderMetadata } from '../useEsigningProviderMetadata';
export const useAddEsigningRecipient = () => {
    const { properties } = useEsigningProviderMetadata();
    const { nameFormat } = properties;
    const [mutate, state] = useMutation(AddEsigningRecipientDocument);
    const addRecipient = (props) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { variables, onSuccess, onError } = props;
        // We need to remove the incorrect name format from the
        // variables, depending on what provider is connected
        if (nameFormat === 'firstNameLastName') {
            variables.input.name = undefined;
        }
        else {
            variables.input.firstName = undefined;
            variables.input.lastName = undefined;
        }
        try {
            const { data } = yield mutate({
                variables,
                update: (cache, result) => {
                    var _a, _b;
                    // eslint-disable-next-line no-underscore-dangle
                    if (((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.addEsigningRecipient) === null || _b === void 0 ? void 0 : _b.__typename) === 'AddEsigningRecipientPayload') {
                        const { recipient } = result.data.addEsigningRecipient;
                        const { __typename, id } = recipient;
                        cache.modify({
                            id: cache.identify({ id: variables.input.fileSystemDocumentId, __typename: 'FileSystemDocument' }),
                            fields: {
                                esigningRecipients(existing = [], { toReference }) {
                                    const newReference = toReference({ __typename, id }, true);
                                    return [...existing, newReference];
                                },
                            },
                        });
                    }
                },
            });
            // eslint-disable-next-line no-underscore-dangle
            switch ((_a = data === null || data === void 0 ? void 0 : data.addEsigningRecipient) === null || _a === void 0 ? void 0 : _a.__typename) {
                case 'AddEsigningRecipientPayload':
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.addEsigningRecipient);
                    break;
                case 'AddEsigningRecipientRejectionList':
                    onError === null || onError === void 0 ? void 0 : onError({ type: 'rejection', reason: data.addEsigningRecipient.rejections[0].reason });
                    break;
                default:
                    throw new Error();
            }
        }
        catch (e) {
            onError === null || onError === void 0 ? void 0 : onError({ type: 'error', error: e });
        }
    });
    return [addRecipient, state];
};
